const url = new URL(window.location.href)
const urlParams = new URLSearchParams(url.search)

if (urlParams.has("click")) {

  const currentDate = new Date(Date.now())
  const newDate = new Date(currentDate.setDate(currentDate.getDate() + 10))

  const retrackClick = urlParams.get("click");
  const cookie = `retrack_click=${retrackClick};expires=${newDate};path=/;`

  document.cookie = cookie
}